var render = function render(){var _vm=this,_c=_vm._self._c;return _c('coozzy-card',{attrs:{"title":_vm.$t('message.contact.export.title'),"sub-title":_vm.$t('message.contact.export.subTitle')}},[_c('coozzy-form-copy-input',{attrs:{"type":"email","name":_vm.$t('message.contact.export.url'),"value":_vm.exportUrl},on:{"click":_vm.copyExportUrlClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }